var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.9,3H21V1.1C21,0.5,20.5,0,19.9,0H1.1C0.5,0,0,0.5,0,1.1v18.8C0,20.5,0.5,21,1.1,21H3v1.9C3,23.5,3.5,24,4.1,24h18.8   c0.6,0,1.1-0.5,1.1-1.1V4.1C24,3.5,23.5,3,22.9,3z M3,4.1V19H2V2h17v1H4.1C3.5,3,3,3.5,3,4.1z M22,22H5V5h17V22z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11,
    x: 8,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11,
    x: 8,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11,
    x: 8,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11,
    x: 8,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11,
    x: 8,
    y: 17
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.599b71db33ae650af6a8a278a5cadcca.svg";
export { ForwardRef as ReactComponent };